import { readToken } from 'utils/readToken';
import axios from 'axios';
import { buildFullUrl } from 'utils/request.js';

export const fetchConfigFromAPI = async () => {
  try {
    const token = readToken();
    const URL = buildFullUrl('app/env');
    const response = await axios.request({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log('error while fetching fetchConfigFromAPI', error);
    return {};
  }
};
